import { render, staticRenderFns } from "./RateLimitInput.vue?vue&type=template&id=6cac7fdd"
import script from "./RateLimitInput.vue?vue&type=script&lang=js"
export * from "./RateLimitInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports